/*
 * Группирует маркеры с близкими координатами и размещает их по спирали Архимеда.
 * Первая точка в группе остаётся без смещения, остальные располагаются по спирали.
 * markers - массив объектов с полем coordinates: [x, y]
 * tolerance - расстояние (в метрах) для группировки
 * startRadius - начальный радиус
 * возвращает новый массив с откорректированными координатами
 */

const ANGLE_COEFFICIENT = 0.36; // множитель угла (регулирует плотность витков спирали)
const RADIUS_COEFFICIENT = 0.12; // множитель радиуса (регулирует расстояние между витками)

export default function groupPointsBySpiral(markers, tolerance = 5, startRadius = 24) {
  // Группировка по координатам с точностью tolerance метров
  const groups = {};
  markers.forEach((marker, idx) => {
    const [x, y] = marker.coordinates;
    // Ключ - округленные координаты
    // Точки в радиусе tolerance будут иметь одинаковый ключ и группу
    const key = `${Math.round(x / tolerance)}_${Math.round(y / tolerance)}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push({ ...marker, originalIndex: idx });
  });

  // Копируем исходный массив
  const result = [...markers];

  // Для каждой группы с более чем одним маркером
  Object.values(groups).forEach((group) => {
    if (group.length > 1) {
      group.forEach((marker, i) => {
        // Первая точка остаётся без смещения
        if (i === 0) {
          result[marker.originalIndex] = marker;
        } else {
          // Для остальных вычисляем смещение по спирали.
          const angle = i * ANGLE_COEFFICIENT; // множитель угла
          // коэффициент для второй точки, чтобы не была слишком далеко от первой
          const secondPointCoefficient = i === 1 ? 0.6 : 1;
          const radius = startRadius * secondPointCoefficient + startRadius * RADIUS_COEFFICIENT * i;

          // Перевод из полярных координат в декартовы (x, y)
          const dx = radius * Math.cos(angle);
          const dy = radius * Math.sin(angle);

          const [x, y] = group[0].coordinates;
          result[marker.originalIndex] = {
            ...marker,
            coordinates: [x + dx, y + dy],
          };
        }
      });
    }
  });

  return result;
}
